import { replaceImageSizeSrc } from "@winging/util/helper/image";
import { Link } from "@/i18n/navigation";

const PricingAddAgent = () => {
  return (
    <div
      className={
        "mt-[136px] rounded-lg border border-primary px-[32px] pb-[26px] pt-[32px]"
      }
    >
      <div className={"text-label2 font-[600] text-primary"}>
        여러 AI에이전트가 필요하신가요? 지금 에이전트를 추가하고 더 많은 고객과
        소통하세요!
      </div>
      <div className={"mt-[0px] flex items-center gap-[6px]"}>
        <span className={"text-title1 font-[800] text-black"}>Winging</span>{" "}
        <span className={"text-heading3 font-[500]"}>에이전트 추가</span>
      </div>
      <div className={"text-label2 text-gray-400"}>
        Starter, Pro 요금제를 통해 제공되는 에이전트는 1개 입니다.
        <br />
        에이전트 추가 제작이 필요한 경우에는 추가요금이 발생합니다.
      </div>
      <div className={"mt-[20px] flex w-full items-end justify-between"}>
        <div>
          <div className={"text-caption2 font-[600] text-[#F84949]"}>
            AI 에이전트 1개당,
          </div>
          <div>
            <span className={"text-heading3 font-[600] text-primary"}>
              ₩ 30,000원
            </span>
            <span className={"ml-[12px] font-[600] text-gray-400"}>/ 월</span>
            <span className={"ml-[4px] text-caption2 font-[600] text-gray-200"}>
              (VAT별도)
            </span>
          </div>
          <div className={"mt-[18px]"}>
            <Link
              // 공개 페이지 대신 로그인 페이지로 이동한다.
              href={"/auth/sign-in"}
              className={
                "flex h-[40px] w-[240px] items-center justify-center rounded-md bg-primary text-title2 text-white"
              }
            >
              에이전트 추가하기
            </Link>
          </div>
        </div>
        <div>
          <img
            className={"h-auto w-[256px] min-w-[256px]"}
            src={replaceImageSizeSrc(
              "https://cdn.winging.app/static/builder/images/add-agent.png",
              256
            )}
            alt={"에이전트 추가 안내 이미지"}
          />
        </div>
      </div>
    </div>
  );
};

export default PricingAddAgent;
